import { Box, Typography } from '@mui/material'
import IntegrationCard from './IntegrationCard'
import styles from './integrationsModal.module.scss'

/**
 * @param {{
 *   apps: import('@/data/integrationsMarketplace/integrationsMarketplaceCatalog.js').MarketplaceApp[],
 *   showPopularHeading?: boolean,
 *   emptyMessage?: string,
 * }} props
 */
export default function IntegrationsGrid({ apps, showPopularHeading = false, emptyMessage = 'No integrations match your filters.' }) {
  return (
    <Box className={styles.gridSection}>
      {showPopularHeading ? (
        <Typography component="h3" className={styles.gridSectionTitle}>
          Popular Integrations
        </Typography>
      ) : null}
      {apps.length === 0 ? (
        <Typography component="p" className={styles.gridEmpty}>
          {emptyMessage}
        </Typography>
      ) : (
        <Box className={styles.integrationsGrid} role="list">
          {apps.map((app) => (
            <Box key={app.slug} role="listitem" className={styles.gridCell}>
              <IntegrationCard app={app} />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )
}
